<template>
  <b-modal
    id="password-reset"
    :title="$t('message.reset_password') | capitalize"
  >
    <div>
      <div v-if="!showSuccess">
        <form @submit.prevent ref="reset">
          <div class="form-group">
            <label for="email-reset">{{
              $t("message.email") | capitalize
            }}</label>
            <input
              id="email-reset"
              class="form-control"
              v-model.trim="email"
              type="email"
              required
            />
          </div>
        </form>
        <p v-if="errorMsg !== ''" class="error">{{ errorMsg }}</p>
        <button @click="resetPassword()" class="btn btn-primary">
          {{ $t("message.reset") | capitalize }}
        </button>
      </div>
      <p v-else>{{ $t("message.password_reset_success") | capitalize }}</p>
    </div>
  </b-modal>
</template>

<script>
import { auth } from "@/firebase";
export default {
  data() {
    return {
      email: "",
      showSuccess: false,
      errorMsg: ""
    };
  },
  methods: {
    async resetPassword() {
      if (this.$refs.reset.checkValidity()) {
        this.errorMsg = "";
        try {
          await auth.sendPasswordResetEmail(this.email);
          this.showSuccess = true;
        } catch (err) {
          this.errorMsg = err.message;
        }
      } else {
        this.$refs.reset.reportValidity();
      }
    }
  }
};
</script>
